import { UserDetails } from '@bn/api-interfaces';
import { AccountRoutes, AppRoutes } from '@bn/dashboard-core/enums';
import { DropdownMenuItem } from '@bn/web-ui/dropdown-menu/models';

const account = `/${AppRoutes.Account}`;

const BASE_ITEMS: DropdownMenuItem[] = [
  { type: 'link', label: 'Account settings', route: `${account}/${AccountRoutes.Settings}`, icon: 'circle-user' },
  { type: 'link', label: 'API key', route: `${account}/${AccountRoutes.ApiKey}`, icon: 'key' },
  { type: 'link', label: 'Change password', route: `${account}/${AccountRoutes.Settings}/${AccountRoutes.ChangePassword}`, icon: 'lock-keyhole' },
  { type: 'divider' },
  { type: 'theme-switch', label: 'Choose theme', action: 'theme-change' },
  { type: 'divider' },
  { type: 'link', label: 'Log out', action: 'logout', icon: 'right-from-bracket' },
];

export function buildUserProfileMenuItems(userDetails?: UserDetails | null): DropdownMenuItem[] {
  const items = [...BASE_ITEMS];

  if (userDetails?.IsSsoAccount) {
    const idx = items.findIndex((item) => item.label === 'Change password');
    if (idx !== -1) items.splice(idx, 1);
  }

  if (userDetails?.Roles?.includes('User')) {
    const extraItems: DropdownMenuItem[] = [];
    if (!userDetails.DpaAccepted) {
      extraItems.push({ type: 'link', label: 'GDPR', route: `${account}/${AccountRoutes.Dpa}`, icon: 'envelope-open' });
    }
    extraItems.push({ type: 'link', label: 'Affiliate program', route: `${account}/${AccountRoutes.Affiliate}`, icon: 'carrot' });
    items.splice(1, 0, ...extraItems);
  }

  return items;
}
